__turbopack_context__.v({
  "caption": "cart-drawer-module__ppMpiG__caption",
  "drawer": "cart-drawer-module__ppMpiG__drawer",
  "empty": "cart-drawer-module__ppMpiG__empty",
  "footer": "cart-drawer-module__ppMpiG__footer",
  "header": "cart-drawer-module__ppMpiG__header",
  "iconButton": "cart-drawer-module__ppMpiG__iconButton",
  "image": "cart-drawer-module__ppMpiG__image",
  "item": "cart-drawer-module__ppMpiG__item",
  "itemActions": "cart-drawer-module__ppMpiG__itemActions",
  "itemBody": "cart-drawer-module__ppMpiG__itemBody",
  "items": "cart-drawer-module__ppMpiG__items",
  "primary": "cart-drawer-module__ppMpiG__primary",
  "productName": "cart-drawer-module__ppMpiG__productName",
  "quantity": "cart-drawer-module__ppMpiG__quantity",
  "secondary": "cart-drawer-module__ppMpiG__secondary",
  "subtotal": "cart-drawer-module__ppMpiG__subtotal",
  "title": "cart-drawer-module__ppMpiG__title",
});
